import React, { useState, useEffect } from "react";
import {
  Bell,
  AlertCircle,
  BookOpen,
  ShoppingCart,
  Menu,
  User,
  CirclePlus,
  Dock,
  Star,
} from "lucide-react";

import NotificationModal from "../Modals/NotificationModal";
import StudentHomeworkModal from "../Modals/StudentHomeworkModal";
import useModal from "../hooks/useModal";
import useNotifications from "../hooks/notification";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { handleStudentId } from "../redux/slice/StudentDetailSlice";
import { use } from "react";

function UserScoreInfo({ userName, userScore }) {
  const { visable, Open, Close } = useModal();
  const navigate = useNavigate();
  const [purchasePackge, setPurchasePackge] = useState();
  const dispatch = useDispatch();
  // User ID'yi localStorage'dan al
  const [userId, setUserId] = useState(null);
  const [homeworkCount, setHomeworkCount] = useState(0);
  // const classvalue = useSelector((state) => state.activeComponent.value);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("postUser"));
    if (user?._id) {
      setUserId(user._id);
      setPurchasePackge(user.purchasedPackages);
    }
  }, []);

  // Notification hook'u kullan
  const {
    notifications,
    unreadCount,
    isLoading: notificationsLoading,
    error: notificationsError,
    markAsRead,
    markAllAsRead,
    deleteNotification,
    clearReadNotifications,
    clearAllNotifications,
    smartCleanup,
    respondToInvitation,
    refresh: refreshNotifications,
  } = useNotifications(userId);

  // Ödev sayısını hesapla
  useEffect(() => {
    if (notifications && notifications.length > 0) {
      const homeworkNotifications = notifications.filter(
        (notification) => notification.type === "homework",
      );

      const activeHomeworks = homeworkNotifications.filter((notification) => {
        const dueDate = new Date(
          notification.data?.dueDate || notification.createdAt,
        );
        const now = new Date();
        return dueDate > now;
      });

      setHomeworkCount(activeHomeworks.length);
    }
  }, [notifications]);

  // Bildirim modalını açma fonksiyonu
  const handleNotificationClick = () => {
    Open("NotificationModal");
    refreshNotifications();
  };
  //userDetail
  const handleUserDetail = (UserId) => {
    dispatch(handleStudentId(UserId));
    navigate("/studentDetail");
  };
  // Ödev modalını açma fonksiyonu
  const handleHomeworkClick = () => {
    if (!userId) {
      alert("Kullanıcı bilgisi bulunamadı!");
      return;
    }
    Open("StudentHomeworkModal");
  };

  // Satın alma modalını açma fonksiyonu
  const handlePurchaseClick = () => {
    // Open("PurchaseModal");
    navigate("/purchase"); // Eğer ayrı bir sayfa kullanmak istersen
  };

  return (
    <div className="rounded-3xl p-0 md:p-4 lg:p-6">
      {/* Mobile Layout and Tablet and  - Horizontal Stats Bar */}
      {purchasePackge?.length > 0 ? (
        <div className="block [@media(min-width:1200px)]:hidden">
          {/* Horizontal Stats Bar - Fixed Height and Spacing */}
          <div
            className="flex items-center justify-between bg-white/80 backdrop-blur-sm
         rounded-xl p-2 shadow-lg mb-3 min-h-[60px]"
          >
            {userScore && (
              <div
                onClick={() => handleUserDetail(userId)}
                className="flex flex-col items-center min-w-[45px] hover:scale-105 transition-transform "
              >
                <Star className="w-8 h-8 text-gray-500" />
                <span className="text-md  font-normal text-red-500   -mt-10 -mr-8">
                  {typeof userScore === "object"
                    ? JSON.stringify(userScore)
                    : userScore}
                </span>
                <span className="text-xs font-normal text-gray-700 text-center leading-tight mt-4">
                  {userName?.split(" ")[0] || "Öğrenci"}
                </span>
              </div>
            )}

            {/* Homework */}
            <button
              onClick={handleHomeworkClick}
              className="flex flex-col items-center min-w-[45px] hover:scale-105 transition-transform p-1"
            >
              <BookOpen className="w-8 h-8 text-gray-500 mb-1" />
              <span className="text-lg  font-normal text-red-500   -mt-12 -mr-10">
                {homeworkCount}
              </span>
              <span className="text-xs font-normal text-gray-700 text-center leading-tight mt-4">
                Ödevler
              </span>
            </button>

            {/* Notifications */}
            <button
              onClick={handleNotificationClick}
              className="flex flex-col items-center min-w-[45px] hover:scale-105 transition-transform p-1"
              disabled={notificationsLoading}
            >
              <Bell className="w-8 h-8 text-gray-500 mb-1" />
              <span className="text-lg  font-normal text-red-500   -mt-12 -mr-8">
                {unreadCount}
              </span>
              <span className="text-xs font-normal text-gray-700 text-center leading-tight mt-4">
                bildirimler
              </span>
            </button>
            <button
              onClick={handlePurchaseClick}
              className="flex flex-col items-center min-w-[45px] hover:scale-105 transition-transform p-1"
            >
              <ShoppingCart className="w-8 h-8 text-gray-500 " />
              <span className="text-xs font-normal text-gray-700 text-center leading-tight ">
                satın al
              </span>
            </button>
            <button
              onClick={() => navigate("/about")}
              className="flex flex-col items-center min-w-[45px] hover:scale-105 transition-transform p-1"
            >
              <Dock className="w-8 h-8 text-gray-500 " />
              <span className="text-xs font-normal text-gray-700 text-center leading-tight ">
                hakkında
              </span>
            </button>
          </div>

          {/* Mobile Purchase Button */}
          <button
            onClick={() => navigate("/cartPage")}
            className="w-full bg-orange-500 text-white font-semibold
           py-3 rounded-xl flex items-center justify-center gap-2 shadow-lg 
           transition-all duration-300 transform hover:scale-[1.02]"
          >
            <CirclePlus className="w-5 h-5" />
            Extralar
          </button>
        </div>
      ) : null}

      {/*  desktop Layout (sm ) - Vertical Sidebar Design */}
      <div className="hidden [@media(min-width:1200px)]:block">
        <div className="flex flex-col gap-2 ">
          {/* Header Section */}
          <div className="flex flex-col justify-center items-center gap-2 border-b-4 border-blue-400 pb-4">
            <button
              className="w-full p-3 bg-gray-100 rounded-xl 
            transition-all duration-300 flex items-center justify-between group"
              onClick={() => handleUserDetail(userId)}
            >
              <div className="flex items-center space-x-3">
                <div
                  className=" w-12 h-12 bg-purple-500 rounded-full 
                flex items-center justify-center text-white text-md xl:text-md font-bold shadow-lg cursor-pointer 
                hover:scale-105 transition-transform "
                  // onClick={() => setActiveTab(0)}
                >
                  {userName.charAt(0).toUpperCase()}
                </div>
                <div className="text-left">
                  <div className="font-semibold text-slate-700 text-sm">
                    <h3 className="text-md font-semibold text-slate-700 mb-1">
                      {userName?.split(" ")[0] || "Öğrenci"}
                    </h3>
                  </div>
                  <div className="w-full h-0.5 bg-purple-500 rounded-md "></div>
                  <div className="text-xs text-gray-600"> Skorunuz</div>
                </div>
              </div>

              {userScore && (
                <div className="flex flex-col items-center   rounded-full">
                  <span className="text-yellow-500">⭐</span>
                  <span className="font-semibold text-sm text-gray-700">
                    {typeof userScore === "object"
                      ? JSON.stringify(userScore)
                      : userScore}
                  </span>
                </div>
              )}
            </button>
          </div>

          {/* Notification Button */}
          <button
            onClick={handleNotificationClick}
            className="relative w-full p-3 bg-yellow-500 
            rounded-xl transition-all duration-300 flex items-center justify-between group"
            disabled={notificationsLoading}
          >
            <div className="flex items-center space-x-3 ">
              <div className="p-2 bg-purple-500 rounded-lg">
                <Bell className="w-5 h-5 text-white" />
              </div>
              <div className="text-left">
                <div className="font-semibold text-slate-700 text-sm">
                  Bildirimler
                </div>
                <div className="w-full h-0.5 bg-purple-500 rounded-md "></div>
                <div className="text-xs text-gray-600">
                  {unreadCount > 0 ? `${unreadCount} yeni` : "Temiz"}
                </div>
              </div>
            </div>
            {unreadCount > 0 && (
              <div
                className="bg-purple-500 text-white text-xs font-bold 
              rounded-full w-6 h-6 flex items-center justify-center animate-pulse"
              >
                {unreadCount > 9 ? "9+" : unreadCount}
              </div>
            )}
          </button>

          {/* Homework Button */}
          <button
            onClick={handleHomeworkClick}
            className="w-full p-3 bg-yellow-500 rounded-xl 
            transition-all duration-300 flex items-center justify-between group"
          >
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-purple-500 rounded-lg">
                <BookOpen className="w-5 h-5 text-white " />
              </div>
              <div className="text-left">
                <div className="font-semibold text-slate-700 text-sm">
                  Ödevlerim
                </div>
                <div className="w-full h-0.5 bg-purple-500 rounded-md "></div>
                <div className="text-xs text-gray-600">
                  {homeworkCount === 0 ? "Henüz yok" : "Aktif ödevler"}
                </div>
              </div>
            </div>
            <div className="text-xl font-bold text-purple-600">
              {homeworkCount}
            </div>
          </button>
          {/* Purchase Button - Desktop */}
          <button
            onClick={handlePurchaseClick}
            className="w-full p-4 bg-orange-500 
            text-slate-800 rounded-xl transition-all duration-300 flex 
            items-center space-x-3 group shadow-lg transform hover:scale-105"
          >
            <div
              className="p-2 bg-purple-500 rounded-lg 
             "
            >
              <ShoppingCart className="w-5 h-5 text-white" />
            </div>
            <div className="text-left">
              <div className="font-bold text-sm">Satın Al</div>
              <div className="w-full h-0.5 bg-purple-500 rounded-md "></div>
              <div className="text-xs opacity-90">Paketleri İnceler</div>
            </div>
          </button>
          {/* Game sayfasına gider */}
          <button
            onClick={() => navigate("/cartPage")}
            className="w-full p-4 bg-[#ADD8E6]
            text-slate-700 rounded-xl transition-all duration-300 flex 
            items-center space-x-3 group shadow-lg "
          >
            <div className="p-2 bg-purple-500 rounded-lg ">
              <CirclePlus className="w-5 h-5 text-white" />
            </div>
            <div className="text-left">
              <div className="font-bold text-sm">Extralar</div>
              <div className="w-full h-0.5 bg-purple-500 rounded-md "></div>
              <div className="text-xs opacity-90">Sınıfınıza göre extralar</div>
            </div>
          </button>
          {/* hakında sayfasının gider */}
          <button
            onClick={() => navigate("/about")}
            className="w-full p-4 bg-gray-200 
            text-slate-700 rounded-xl transition-all duration-300 flex 
            items-center space-x-3 group shadow-lg "
          >
            <div className="p-2 bg-purple-500 rounded-lg ">
              <Menu className="w-5 h-5 text-white" />
            </div>
            <div className="text-left">
              <div className="font-bold text-sm">Hakkımızda</div>
              <div className="w-full h-0.5 bg-purple-500 rounded-md "></div>
              <div className="text-xs opacity-90">iletişim ve yasal haklar</div>
            </div>
          </button>
        </div>
      </div>

      {/* Error Message for Notifications */}
      {notificationsError && (
        <div
          className="mb-4 p-3 bg-red-100 border border-red-200 
        rounded-xl flex items-center space-x-2 text-red-700"
        >
          <AlertCircle className="w-4 h-4" />
          <span className="text-sm">Bildirimler yüklenirken hata oluştu</span>
        </div>
      )}
      {/*bilgirim componenti  */}
      <NotificationModal
        visable={visable.NotificationModal}
        Close={() => Close("NotificationModal")}
        notifications={notifications}
        unreadCount={unreadCount}
        onMarkAsRead={markAsRead}
        onMarkAllAsRead={markAllAsRead}
        onDeleteNotification={deleteNotification}
        onClearReadNotifications={clearReadNotifications}
        onClearAllNotifications={clearAllNotifications}
        onSmartCleanup={smartCleanup}
        // Buraya eklediğimiz fonksiyon modal içindeki butonlara bağlanacak
        onRespond={respondToInvitation}
      />

      <StudentHomeworkModal
        visable={visable.StudentHomeworkModal}
        Close={() => Close("StudentHomeworkModal")}
        userId={userId}
      />
    </div>
  );
}

export default UserScoreInfo;
